import React from "react";

function Chip({ className, label, onDelete, disabled = false }) {
	return (
		<div
			className={`inline-flex items-center border-2 border-stone-400 py-1 px-3 rounded-full mr-2 ${className}`}
		>
			<span>{label}</span>
			{onDelete && disabled === false && (
				<button className="ml-2 focus:outline-none" onClick={onDelete}>
					<svg
						className="w-4 h-4 fill-current"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 20 20"
					>
						<path d="M10 0a10 10 0 1010 10A10 10 0 0010 0zm4.47 13.64a1 1 0 01-1.41 1.41L10 11.42l-3.05 3.63a1 1 0 01-1.41-1.41L8.59 10 5.53 6.36a1 1 0 011.41-1.41L10 8.59l3.05-3.63a1 1 0 111.41 1.41L11.41 10l3.06 3.64z" />
					</svg>
				</button>
			)}
		</div>
	);
}

export default Chip;
